import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-modal";
import "../../../styles/member-report/member-report.css";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import MemberReportStat from "./member-checkins-stat/MemberReportStat";
import GymMemberReport from "./gym-member-report/GymMemberReport";
import MemberReportFilter from "./member-checkins-stat/MemberReportFilter";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts.js";
import GymwiseCheckinsReport from "./gym-member-report/GymwiseCheckinsReport.jsx";
import {
  fetchGymwiseCheckinMetricsData,
  fetchMemberCheckinMetricsData,
} from "../../../redux/prospect-reducers/prospectSlice.js";
import { getCommaSeparatedValues } from "./MemberReportMocks.js";
import TrialAssignForm from "../../pt/three-day-trial/TrialAssignForm.jsx";
import ThreedayTrialHistory from "../../pt/three-day-trial/ThreedayTrialHistory.jsx";
import TrainerMemberMap from "../../trainer-member-engagement/trainer-member-map/TrainerMemberMap.jsx";
import BCAReport from "../../trainer-member-engagement/bca-report/BCAReport.jsx";
import DetailModHeader from "../../common-components/DetailModHeader.jsx";
import MemberDetailModal from "./member-detail-modal/MemberDetailModal.jsx";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const MemberReport = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedDate: FORMATTED_TODAY_DATE_YYYYMMDD,
    selectedCheckinTimes: [],
    selectedMemberType: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    start_date: allFilters.selectedDate || "",
    end_date: allFilters.selectedDate || "",
    checkin_time_filter: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getMemberStats(filters) {
    dispatch(
      fetchMemberCheckinMetricsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getGymStats(filters) {
    dispatch(
      fetchGymwiseCheckinMetricsData({
        filters: {
          ...filters,
          page: 1,
          limit: 1000,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      start_date: allFilters.selectedDate || "",
      end_date: allFilters.selectedDate || "",
      checkin_time_filter: getCommaSeparatedValues(
        allFilters.selectedCheckinTimes
      ),
    }));
  }, [allFilters]);

  useEffect(() => {
    getMemberStats(filters);
    getGymStats(filters);
  }, [filters]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        {modValues.modName === "gym-report" ? (
          <GymwiseCheckinsReport
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            onClose={onCloseModal}
            prevAllFilters={allFilters}
          />
        ) : modValues.modName === "trial_assign" ? (
          <div
            className={`createNewCTOModalContainer mod-width-50p mod-height-60vh`}
          >
            {/* <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            /> */}

            <TrialAssignForm
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={onCloseModal}
            />
          </div>
        ) : modValues.modName === "trial_history" ? (
          <div
            className={`createNewCTOModalContainer mod-width-95vw mod-height-95vh`}
          >
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />

            <ThreedayTrialHistory
              rowData={modValues.rowData}
              userInfoData={userInfoData}
            />
          </div>
        ) : modValues.modName === "trainer_member_map" ? (
          <div className={`createNewCTOModalContainer mod-width-50p`}>
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />

            <TrainerMemberMap
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={onCloseModal}
            />
          </div>
        ) : modValues.modName === "BCA_history" ? (
          <div
            className={`createNewCTOModalContainer mod-width-95vw mod-height-95vh`}
          >
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />

            <BCAReport
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          </div>
        ) : modValues.modName === "member_detail" ? (
          <MemberDetailModal
            userInfoData={userInfoData}
            onClose={onCloseModal}
            filterType={modValues.filterType}
            prevFilters={modValues.filters}
            setModValues={setModValues}
          />
        ) : null}
      </Modal>

      <PageHeadingNew
        heading="Live Member Report"
        subheading="Real-time member check-ins and analytics"
        onReload={() => {
          getMemberStats(filters);
          getGymStats(filters);
        }}
      />

      <div className="mt30"></div>

      <MemberReportFilter
        allFilters={allFilters}
        setAllFilters={setAllFilters}
      />

      <MemberReportStat setModValues={setModValues} filters={filters} />

      <GymMemberReport
        setModValues={setModValues}
        userInfoData={userInfoData}
        filters={filters}
      />
    </>
  );
};

export default MemberReport;
